import React, { useState, useEffect, useContext } from 'react'
import { NavLink, Link, useLocation } from 'react-router-dom'
import './menus.css'
import { PopupCloseContext, UserInitalValue } from '../../shared/contexts/popupclose-context'
import { AuthContext } from '../../shared/contexts/AuthContextProvider'
import Buttons from '../../components/buttons/buttons'

export default function Menus(props?:any) {
  const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
  // const [clickedIndex,setClickedIndex] = useState([])
  const [windowSize, setWindowSize] = useState(getWindowSize())
  const location = useLocation()
  const { pathname } = location
  const splitLocation = pathname.split('/')
  const {isSiteAdmin, chathistory} = useContext(AuthContext)
  const toggle = () => {
    setMultiplePopup(null)
    props?.setIsOpen(!props?.isOpen)
  }
  const historyItems = chathistory || []
  useEffect(() => {
    if (windowSize.innerWidth > 1400) {
      props?.setIsOpen(true)
    } else {
      props?.setIsOpen(false)
    }
  }, [windowSize])
  
  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }
  type GetMenu ={
    role:boolean | undefined,
    menu:any[]
  }
  function activeClass(item: { path: string; activepath?: { toString: () => string; }[]; }) {
    let ischecked = false
    if (item?.activepath) {
      item?.activepath.forEach(element => {
        if (splitLocation[1] === item.path || splitLocation[1] === element) {
          ischecked = true
        }
      })
      return ischecked
    }
  }

  const menuitem = [
    {
      path: '/',
      activepath: ['/'],
      name: 'Home',
      icon: 'icon-home font-20'
    },
    {
      path: '/settings',
      activepath: ['settings'],
      name: 'Settings',
      icon: 'icon-settings font-18'
    }
  ]

  const ownerPaths = ['/settings']
  const userMenu = menuitem?.filter((item:any)=>!ownerPaths.includes(item.path))
  const getMenu : GetMenu[]=[
  {role: isSiteAdmin,menu:menuitem},
  {role:true,menu:userMenu}
  ]
  const menus = getMenu?.find(obj=>(obj.role))?.menu ??[]


  return (
    <div className={`side-menus ${props?.isOpen ? 'side-menus-expanded' : 'side-menus-collapsed'}`}>
      <div className="branding-container d-flex align-items-center p-relative border-bottom10 px-3 py-2">
        <Link to='/' className="d-flex align-items-center" title='USAF SAF/FMBOP'>
          <img src='/assets/images/usaf-logo.svg' alt='USAF SAF/FMBOP' height={40} width={40}/>
          <div className={`bordered10 divider vertical mx-3 ${props?.isOpen ? 'd-block' : 'd-none'}`}></div>
          <h3 className={`m-0 font-18 segoeui-semibold whitetext ${props?.isOpen ? 'd-block' : 'd-none'}`}>SAF/FMBOP</h3>
        </Link>
        <div className="menus-toggle">
          <Buttons 
            label={props?.isOpen ? 'Collapse the Menu' : 'Expand the menu'}
            type="button" 
            className='btn font-0'
            icon={`icon-menu-toggle font-18 ${props?.isOpen ? 'whitetext' : 'rotate180 title-color16'}`} 
            onClick={toggle} 
            />
        </div>
      </div>
      <div className="menus p-3 border-bottom10">
        <ul>
          {menus?.map((item, index) => (
            <li key={item.name}>
              <NavLink to={item.path} key={index} className={activeClass(item) ? 'link active' : 'link'} title={item.name}>
                <div className={item.icon}></div>
                <div className='menu-title segoeui-semibold ms-2'>{item.name}</div>
              </NavLink>
            </li>
          ))
          }
        </ul>
      </div>
      <div className="history p-3">
        {props?.isOpen ?
        <>
        <div className='segoeui-semibold font-16 subtitle-color1 mb-2' tabIndex={0} aria-label='History'>History</div>
        <div className="menu-history-items">
          {historyItems.length > 0 ?
            historyItems.map((item:any) => (
              <Link 
                to={`/#history/${item.id}`} // Links to home page with a hash for scrolling
                title={item?.query} 
                className="d-flex align-items-center justify-content-between gap-2 py-1 hover-primary-text" 
                key={item.id}>
                <div className={`font-13 lineClamp1 hover-primary-text ${location.hash === `#history/${item.id}` ? 'title-color18 segoeui-semibold ' : 'whitetext'}`}>{item?.query}</div>
                <div className='font-11 subtitle-color'>{item?.formattedTimestamp.split(',')[0]}</div>
              </Link>
            ))
            :
            <div className='subtitle-color text-center' tabIndex={0} aria-label='No History'>No History</div>
          }
        </div>
        </>
        :
        <Buttons 
            label='History'
            type="button" 
            className='btn-sm btn-sm font-0 border-radius1 py-1 btn-hover'
            icon='icon-history-list font-24 whitetext mx-auto' 
            onClick={toggle} 
            />
      }
      </div>
    </div>
  )
}